// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"5a119416","74":"1d84adfe","611":"c8204de4","641":"af6b3459","970":"8e08df07"}[chunkId] + ".chunk.js";
};